import { z } from 'zod';
/**
 * One catalog entry. Mirrors the `Session` type in @daddytime/sessions but
 * lives here as a wire-shape contract for GET /sessions specifically.
 */
export const SessionSchema = z.object({
    id: z.string(),
    title: z.string(),
    icon: z.string(),
    description: z.string(),
    audioFile: z.string().optional(),
    requiresAuth: z.boolean().optional(),
});
/**
 * Catalog grouped by category name. Empty categories are dropped server-side.
 */
export const SessionCategoriesSchema = z.record(z.string(), z.array(SessionSchema));
/**
 * GET /sessions response body.
 */
export const SessionsResponseSchema = z.object({
    sessions: SessionCategoriesSchema,
});
